/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__validation__model__ValidationState;

(function (jove__app__validation__model__ValidationState) {
  jove__app__validation__model__ValidationState["SUCCESS"] = "success";
  jove__app__validation__model__ValidationState["PENDING"] = "pending";
  jove__app__validation__model__ValidationState["FAIL"] = "fail";
})(jove__app__validation__model__ValidationState || (jove__app__validation__model__ValidationState = {}));